import React, { useState, useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import {
	makeStyles,
	Box,
	Grid,
	IconButton,
	InputBase
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';

import qs from 'qs';

import { transformQuery } from '../../../../../lib/helpers/queryTransformer';
import { getByCategory } from '../../../../../store/office/actions';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: '#FAFAF5',
		marginTop: 30,
		marginBottom: 30,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around'
	},
	searchBox: {
		width: '100%',
		height: 40,
		backgroundColor: '#F0F0EB',
		padding: 1,
		marginTop: 20,
		marginBottom: 20,
		marginLeft: 24,
		marginRight: 24
	},
	iconButton: {
		borderRadius: 0,
		width: 38,
		height: 38,
		backgroundColor: '#FFFFFF',
		color: theme.palette.primary.dark
	},
	input: {
		fontFamily: 'Ubuntu',
		marginLeft: 10,
		fontSize: '14px',
		letterSpacing: '0px',
		width: '90%',
		[theme.breakpoints.only('xs')]: {
			width: '80%'
		}
	}
}));

export default withNamespaces('office')((props) => {
	const { t, category, page } = props;
	const classes = useStyles();

	const history = useHistory();

	const queries = qs.parse(history.location.search, {
		ignoreQueryPrefix: true
	});

	const [search, setSearch] = useState(queries.s ? queries.s : null);

	const handleSearch = () => {
		window.scrollTo(0, 0);
		history.push({
			pathname: page ? `/${page}` : `/${category}`,
			search: transformQuery({ ...queries, s: search || '', page: 1 })
		});
		getByCategory(history.location.search);
	};

	useEffect(() => {
		getByCategory(history.location.search);
	}, [history.location.search]);

	return (
		<Grid container spacing={0} className={classes.root}>
			<Grid item className={classes.searchBox}>
				<Box>
					<IconButton className={classes.iconButton} onClick={handleSearch}>
						<SearchIcon />
					</IconButton>
					<InputBase
						onChange={(evt) => setSearch(evt.target.value)}
						value={search}
						className={classes.input}
						placeholder={t('search')}
						inputProps={{ 'aria-label': 'search news' }}
					/>
				</Box>
			</Grid>
		</Grid>
	);
});
